import { useMemo } from "react";
import { useNotifications } from "@faire/retailer/components/Header/HeaderNotifications/hooks/useNotifications";
export var useHasHighPriorityNotification = function() {
    var notifications = useNotifications().notifications;
    return useMemo(function() {
        var _notifications_some;
        return (_notifications_some = notifications === null || notifications === void 0 ? void 0 : notifications.some(function(param) {
            var priority = param.priority;
            return priority === "HIGH";
        })) !== null && _notifications_some !== void 0 ? _notifications_some : false;
    }, [
        notifications
    ]);
};
